import http from '@/uteis/http'

export default class UsuarioService {
  async buscarUsuarios (filtro) {
    var args = {
      SistemaID: filtro.sessao.sistemaId,
      EstruturaID: filtro.sessao.idDepartamento,
      AmbienteID: filtro.sessao.ambienteId,
      offset: filtro.offset,
      range: filtro.range
    }

    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/gsi', { params: args }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/gsi', { params: args }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarUsuariosCaixaMensagem (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/interessado', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/interessado', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
